<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.administratorSalaryList.push"
    :is-show-store-select="isAdministrator"
    :has-private-store="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
  >
    <v-column-time/>
    <v-column-avatar label="管理员"/>
    <el-table-column v-if="isAdministrator" label="所属门店" width="100" align="center">
      <template v-slot="{ row }">{{ row.store_name | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="职位" width="100" align="center" prop="role_name"/>
    <el-table-column label="底薪（元）" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.base_pay | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="社保费用" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.social_insurance | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="门店社保费用" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.store_insurance | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="个人社保费用" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.personal_insurance | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="业绩任务" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.task_income | toYuan }} 元</span>
      </template>
    </el-table-column>

    <el-table-column label="未完成底薪比例" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.base_pay_rate | toYuan }} %</span>
      </template>
    </el-table-column>

    <el-table-column label="完成后提成比例" width="130" align="center">
      <template v-slot="{ row }">
        <span>{{ row.commission_rate | toYuan }} %</span>
      </template>
    </el-table-column>

    <el-table-column width="310">
      <template v-slot="{ row }">
        <v-list-button name="修改薪资" size="large" :to="RouteConfig.administratorSalaryEdit.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`admin-salary-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>管理员</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div v-if="isAdministrator" class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name | formatStoreName }}</span>
            </div>

            <div class="list-item-detail">
              <span>职位</span>
              <span>{{ v.role_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>底薪（元）</span>
              <span>{{ v.base_pay | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>社保费用（元）</span>
              <span>{{ v.social_insurance | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>门店社保费用（元）</span>
              <span>{{ v.store_insurance | toYuan }}</span>
            </div>


            <div class="list-item-detail">
              <span>个人社保费用（元）</span>
              <span>{{ v.personal_insurance | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>业绩任务（元）</span>
              <span>{{ v.task_income | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>未完成底薪比例</span>
              <span>{{ v.base_pay_rate | toYuan }} %</span>
            </div>

            <div class="list-item-detail">
              <span>完成后提成比例</span>
              <span>{{ v.commission_rate | toYuan }} %</span>
            </div>


            <div class="list-item-button">
              <v-list-button name="修改薪资" size="large" :to="RouteConfig.administratorSalaryEdit.to(v.id)"/>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index } from '@/api/administratorRoleMerge';
import { getLegalQueryList } from "@/utils/formats";
import { formatStoreName } from '@/filters';

export default {
  name: RouteConfig.administratorSalaryList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      limit: '',
      is_asc: 0,
      page: 1,
      size: 8,
    },
    isLoading: false,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    formatStoreName,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
